import * as React from 'react';
import $ from './channel-header.scss';

export interface ChannelHeaderProps {
    channelName?: string;
    logoPath?: string;
}

export const ChannelHeader: React.FC<ChannelHeaderProps> = ({ logoPath, channelName }) => (
    <div className={$['channel-header']}>
        {logoPath && <img src={logoPath} alt={channelName} className={$['channel-logo']} />}
    </div>
);
